var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMPlusBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 3.2002H19.2V6.4002H44.8V3.2002Z",
    fill: "#2A2A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1999 6.40039H12.7999V9.60039H51.1999V6.40039Z",
    fill: "#2A2A2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4 9.6001H9.59998V12.8001H54.4V9.6001Z",
    fill: "#2A2A2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5999 12.8003H6.3999V16.0003H57.5999V12.8003Z",
    fill: "#2A2A2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7999 16H3.19995V19.2H60.7999V16Z",
    fill: "#2A2A2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39995 19.2002H3.19995V44.8002H6.39995V19.2002Z",
    fill: "#2A2A2A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8 19.2002H57.6V44.8002H60.8V19.2002Z",
    fill: "#2A2A2A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7999 44.8003H3.19995V48.0003H60.7999V44.8003Z",
    fill: "#2A2A2A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5999 48H6.3999V51.2H57.5999V48Z",
    fill: "#2A2A2A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4 51.2002H9.59998V54.4002H54.4V51.2002Z",
    fill: "#2A2A2A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1999 54.4004H12.7999V57.6004H51.1999V54.4004Z",
    fill: "#2A2A2A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 57.6001H19.2V60.8001H44.8V57.6001Z",
    fill: "#2A2A2A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8001 6.3999H19.2001V9.5999H44.8001V6.3999Z",
    fill: "#3498DB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2001 9.6001H12.8V12.8001H51.2001V9.6001Z",
    fill: "#3498DB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4 12.7998H9.59998V15.9998H54.4V12.7998Z",
    fill: "#3498DB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 16H6.40002V19.2H57.6V16Z",
    fill: "#3498DB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 19.1997H6.40002V44.7997H57.6V19.1997Z",
    fill: "#3498DB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 44.7998H6.40002V47.9998H57.6V44.7998Z",
    fill: "#3498DB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4 48H9.59998V51.2H54.4V48Z",
    fill: "#3498DB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2001 51.1997H12.8V54.3997H51.2001V51.1997Z",
    fill: "#3498DB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8001 54.3999H19.2001V57.5999H44.8001V54.3999Z",
    fill: "#3498DB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4001 6.3999H19.2001V9.5999H38.4001V6.3999Z",
    fill: "#5DADE2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 9.6001H12.8V12.8001H38.4V9.6001Z",
    fill: "#5DADE2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 12.7998H9.59998V15.9998H38.4V12.7998Z",
    fill: "#5DADE2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 16H6.40002V19.2H38.4V16Z",
    fill: "#5DADE2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6 19.1997H6.40002V25.5997H41.6V19.1997Z",
    fill: "#5DADE2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 25.6001H6.40002V28.8001H44.8V25.6001Z",
    fill: "#85C1E9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5999 19.2002H38.3999V44.8002H57.5999V19.2002Z",
    fill: "#2980B9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 38.4004H25.6V44.8004H57.6V38.4004Z",
    fill: "#2980B9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 44.8003H19.2V48.0003H57.6V44.8003Z",
    fill: "#2471A3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 48H25.6V51.2H57.6V48Z",
    fill: "#2471A3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2 51.2002H32V54.4002H51.2V51.2002Z",
    fill: "#2471A3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 54.4004H35.2V57.6004H44.8V54.4004Z",
    fill: "#2471A3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 19.2002H28.8V44.8002H35.2V19.2002Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 28.7998H19.2V35.1998H44.8V28.7998Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 22.3999H32V44.7999H35.2V22.3999Z",
    fill: "#E0E0E0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 32H22.4V35.2H44.8V32Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMPlusBtn);
export default __webpack_public_path__ + "static/media/MPlusBtn.4f536735a6c70067e453b390b4255837.svg";
export { ForwardRef as ReactComponent };